import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class AppFeedbackService {

  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'AppFeedback/';
  // fetch all AppFeedback in the database
  allAppFeedbackData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getAppFeedback(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  postAppFeedback(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteAppFeedback(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateAppFeedback(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
